import React from "react"
import { Link } from "react-router-dom"
import { SmallParagraph, SmallText } from "../../components/typography/Typography"
import orana from '../../assets/orana.webp'
import stadium from '../../assets/stadium.png'
import bleachers from '../../assets/bleacher.png'
import flooring from '../../assets/flooring/cover-court.webp'
import equipment from '../../assets/equipment/ceiling-hung.webp'

type ProductNavItem = {
  href: string
  title: string
  description: string
  image: string
  alt: string
}

const productNav: ProductNavItem[] = [
  {
    href: "/retractable-seating",
    title: "Retractable Seating",
    description: "Seating range suitable for multiple applications",
    image: orana,
    alt: "Retractable Seating",
  },
  {
    href: "/stadium-seating",
    title: "Stadium Seating",
    description: "Seating specially designed to withstand rough stadium conditions",
    image: stadium,
    alt: "Stadium Seating",
  },
  {
    href: "/bleachers",
    title: "Bleachers",
    description: "Bleachers designed for high durability and safety",
    image: bleachers,
    alt: "Bleachers",
  },
  {
    href: "/sports-flooring",
    title: "Sports Flooring",
    description: "Sprung hardwood courts, fixed and portable",
    image: flooring,
    alt: "Sports Flooring",
  },
  {
    href: "/facility-equipment",
    title: "Facility Equipment",
    description: "Backstops, padding, curtains and floor protection",
    image: equipment,
    alt: "Facility Equipment",
  },
]

export const ProductsPanel = ({ onClick }: { onClick: () => void }) => {
  return (
    // Horizontal rows on mobile — same shape as the industries panel — and a
    // five-across grid of stacked cards once there is room for it.
    <div className="flex flex-col gap-2 p-4 lg:grid lg:grid-cols-5">
      {productNav.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          onClick={onClick}
          className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-2 transition hover:bg-gray-50 lg:flex-col lg:items-stretch lg:p-3"
        >
          <img
            src={item.image}
            alt={item.alt}
            className="h-24 w-48 shrink-0 rounded object-cover lg:h-32 lg:w-full lg:rounded-lg"
          />
          <div className="flex flex-col gap-2">
            <SmallParagraph>{item.title}</SmallParagraph>
            <SmallText className="capitalize">{item.description}</SmallText>
          </div>
        </Link>
      ))}
    </div>
  )
}
